namespace st.search {
    angular.module('st.search', []);

    export const UrlSeparator = ':';
    export const SortSeparator = ',';
    export const DefaultGroup = '';
    export const TermPropertyName = 'term';
    export const PagePropertyName = 'page';
    export const SortPropertyName = 'sort';

    interface SearchBoxAttributes extends angular.IAttributes {
        stSearchBox: string;
        stSearchBoxInput: string;
        stSearchBoxButton: string;
    }

    const SearchBox: angular.IDirectiveFactory = ($window: angular.IWindowService) => {
        function submitSearch(query: string, url: string) {
            if ($window.location.pathname.toLocaleUpperCase() === url.toLocaleUpperCase()) {
                $window.location.hash = '/?term=' + encodeURIComponent(query);
            } else {
                $window.location.assign(url + '#/?term=' + encodeURIComponent(query));
            }
        }
        return {
            restrict: 'A',
            link: (scope: angular.IScope, el: angular.IAugmentedJQuery, attrib: SearchBoxAttributes) => {
                const input = angular.element(attrib.stSearchBoxInput || '.form-control', el);
                const btn = angular.element(attrib.stSearchBoxButton || '.btn', el);
                if (attrib.stSearchBox && input.length === 1 && btn.length) {
                    input.on('keypress', (e) => {
                        if (e.keyCode === 13 && input.val()) {
                            e.preventDefault();
                            e.stopPropagation();
                            scope.$apply(function() {
                                submitSearch(input.val(), attrib.stSearchBox);
                            });
                        }
                    });
                    btn.on('click', (e) => {
                        if (input.val()) {
                            scope.$apply(function() {
                                submitSearch(input.val(), attrib.stSearchBox);
                            });
                        }
                    });
                }
            }
        };
    };
    SearchBox.$inject = ['$window'];

    angular.module('st.search')
        .directive('stSearchBox', SearchBox);
}
